import { Grid, IconButton, Tooltip } from '@mui/material';
import { FC, useState } from 'react';

import FaIcon from '@components/FaIcon';
import useCharts from '@hooks/useCharts';
import { sendAmplitudeData } from '@utils/amplitude';
import {
  CLICKED_CHART_DOWNVOTE,
  CLICKED_CHART_UPVOTE,
  REMOVED_VOTE
} from '@constants/eventNames';
import { ChartCreationMethod } from '@DStypes/chart';

interface UpDownVoteProps {
  rating: number;
  chartDetails: {
    chart_long_desc: string;
    chart_short_desc: string;
    chart_title: string;
  };
  chartId: string;
  amplitudeProps: {
    data_type_combination: string;
    method_used: ChartCreationMethod;
    chart_config_count: number;
  };
  isEditChart?: boolean;
  setRating?: React.Dispatch<React.SetStateAction<number>>;
}

const UpDownVote: FC<UpDownVoteProps> = ({
  rating,
  chartDetails,
  chartId,
  amplitudeProps,
  isEditChart = false,
  setRating
}) => {
  const { onUpdateChart } = useCharts({ chartId: chartId });

  const [chartRating, setChartRating] = useState<number>(rating);

  const handleRatingChange = (chartRating: number) => {
    onUpdateChart(chartDetails, chartRating);
  };

  const onClickUpvote = () => {
    const newRating = chartRating === 1 ? 0 : 1;

    if (setRating) setRating(newRating);
    setChartRating(newRating);
    handleRatingChange(newRating);

    if (newRating === 1)
      sendAmplitudeData(CLICKED_CHART_UPVOTE, {
        ...amplitudeProps
      });
    else sendAmplitudeData(REMOVED_VOTE, { Rating: 'upvote', Type: 'Chart' });
  };

  const onClickDownvote = () => {
    const newRating = chartRating === -1 ? 0 : -1;

    if (setRating) setRating(newRating);
    setChartRating(newRating);
    handleRatingChange(newRating);
    if (newRating === -1)
      sendAmplitudeData(CLICKED_CHART_DOWNVOTE, {
        ...amplitudeProps
      });
    else sendAmplitudeData(REMOVED_VOTE, { Rating: 'downvote', Type: 'Chart' });
  };

  return (
    <>
      <Grid item>
        <Tooltip title={isEditChart ? 'Select if chart is helpful! :)' : ''}>
          <IconButton color='secondary' onClick={onClickUpvote}>
            <FaIcon
              icon={[`${chartRating == 1 ? 'fas' : 'far'}`, 'thumbs-up']}
              typographyProps={{
                variant: isEditChart ? 'lgg' : 'lg',
                color: 'success'
              }}
            />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item>
        <Tooltip title={isEditChart ? 'Select if chart is not helpful :(' : ''}>
          <IconButton color='secondary' onClick={onClickDownvote}>
            <FaIcon
              icon={[`${chartRating == -1 ? 'fas' : 'far'}`, 'thumbs-down']}
              typographyProps={{
                variant: isEditChart ? 'lgg' : 'lg',
                color: 'error'
              }}
            />
          </IconButton>
        </Tooltip>
      </Grid>
    </>
  );
};

export default UpDownVote;
